const KeyboardHint = ({ empty, children }) => (
  <kbd
    className={`bg-gray-200 p-1 inline-block border border-gray-300 rounded tracking-[.15em] ${
      empty ? "w-20" : ""
    }`}
  >
    {children}
  </kbd>
);
export default KeyboardHint;
